<template>
  <el-card shadow="never" class="aui-card--fill">
    <div class="aui-form-item">
      <span style="padding-right: 20px;">平推推送间隔</span>
      <el-select v-model="pushInterval" filterable clearable placeholder="请选择推送间隔">
        <el-option
          v-for="(item,index) in intervalList"
          :key="index"
          :label="item.label"
          :value="item.value">
        </el-option>
      </el-select>
    </div>
  </el-card>
</template>
<script>
import { getList } from '../../../api/list'
export default {
  data () {
    return {
      intervalList:[],
      pushInterval:'',
    }
  },
  created() {
    // this.getProductFlag()
  },
  methods: {
    async getProductFlag() {
      getList('/sys/dict/data/list?dataType=pushtime').then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        console.log(res)
        this.intervalList = [];
        if (res.data != null) {
          res.data.forEach(element => {
            this.intervalList.push({ label: element.dictLabel, value: element.dictLabel })
          })
        }
      }).catch(() => { })

    },
  }
}
</script>
<style lang="scss" scoped>
.aui-form-item{
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
}
</style>